import { textToKebab } from './toKebabCase'

let id = 0

const idGenerator = (text: string) => {
  id++
  return `${textToKebab(text)}-${id}`
}

export default idGenerator
